export class AiChatGreeting {
  constructor ({
    content
  }) {
    this.content = content
  }
}
